import { ACTION_SUBJECT_PREFIX } from '../../constants/analytics';
import { type FireAnalyticsEvent } from '../../types';
import { type SearchLinkTypes } from '../../ui/search-link/types';
import { type CommonAttributes, type NonPrivacySafeAttributes } from './types';

type onDropdownResultClickedArgs = {
	commonAttributes: CommonAttributes;
	nonPrivacySafeAttributes: NonPrivacySafeAttributes;
	resultType: SearchLinkTypes;
	duration?: number;
	index?: number;
};

export const onDropdownResultClicked = ({
	commonAttributes,
	nonPrivacySafeAttributes,
	resultType,
	duration,
	index,
}: onDropdownResultClickedArgs): FireAnalyticsEvent => ({
	eventType: 'ui',
	actionSubject: `${ACTION_SUBJECT_PREFIX}DropdownResult`,
	action: 'clicked',
	attributes: {
		additionalAttributes: {
			resultType,
			index,
			duration,
		},
		commonAttributes,
	},
	nonPrivacySafeAttributes,
});
